/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProfileDialogTransfer.vue?vue&type=template&id=e6222f00&scoped=true"
import script from "./ProfileDialogTransfer.vue?vue&type=script&lang=js"
export * from "./ProfileDialogTransfer.vue?vue&type=script&lang=js"
import style0 from "./ProfileDialogTransfer.vue?vue&type=style&index=0&id=e6222f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6222f00",
  null
  
)

export default component.exports